import { createApp } from 'vue'

const params = new URLSearchParams(window.location.search)

if (params.has('preview')) {
  import('./Preview.vue').then(({ default: Preview }) => {
    createApp(Preview).mount('#app')
  })
} else {
  import('./App.vue').then(({ default: App }) => {
    const platform = params.get('platform')
    if (platform) {
      document.body.classList.add(`platform-${platform}`)
    }
    createApp(App).mount('#app')
  })
}
